import { Ref, RefCallback, useMemo } from 'react';

export function useMergeRef<T>(...refs: Array<Ref<T> | undefined>): RefCallback<T> {
  return useMemo(() => {
    if (refs.every((ref) => ref == null)) {
      throw new Error('At least one ref is required');
    }
    return (current) => {
      refs.filter(Boolean).forEach((ref) => {
        if (!ref) return;
        if (typeof ref === 'function') return ref(current);
        // oxlint-disable-next-line no-param-reassign
        ref.current = current;
      });
    };
  }, [refs]);
}
